// JOBE-0158.3: AttentionRow — W1 attention-list row.
// CSS grid: [dot] [who-dept] [what] [since] [ref] [action]
// The whole row is clickable — any click fires onOpen.
// Accessibility: root is a <button> (keyboard navigable; Enter fires onOpen).
// design-system.md §"Attention row" + screen-guide.md §W1.

import './AttentionRow.css';

const SEVERITY_CLASS = {
  high: 'attn-row--high',
  med: 'attn-row--med',
  low: 'attn-row--low',
};

/**
 * @param {object} props
 * @param {'high'|'med'|'low'} props.severity
 * @param {string} props.who
 * @param {string} props.dept
 * @param {React.ReactNode} props.what
 * @param {string} props.since
 * @param {string} [props.rowRef]  — small mono reference string.
 *   NOTE: named `rowRef` (not `ref`) because React treats `ref` as a special
 *   prop that never reaches the component's props object. Consumers must pass
 *   `rowRef="finance/ap-aging"` — spec says `ref`, but that is a React
 *   reserved word at the JSX layer (JOBE-0158.3 API deviation noted in spec log).
 * @param {Function} props.onOpen
 */
export function AttentionRow({ severity, who, dept, what, since, rowRef, onOpen }) {
  return (
    <button
      className={['attn-row', SEVERITY_CLASS[severity]].filter(Boolean).join(' ')}
      onClick={onOpen}
      type="button"
    >
      {/* Severity dot */}
      <span className="attn-row__dot" aria-hidden="true" />

      {/* Who + dept stacked */}
      <span className="attn-row__who-dept">
        <span className="attn-row__who">{who}</span>
        <span className="attn-row__dept">{dept}</span>
      </span>

      {/* What — ReactNode, italic prose for <em> */}
      <span className="attn-row__what">{what}</span>

      {/* Since */}
      <span className="attn-row__since">{since}</span>

      {/* Ref — only render when provided */}
      {rowRef && <span className="attn-row__ref">{rowRef}</span>}

      {/* Action — courtesy hit-target; click is on the whole row */}
      <span className="attn-row__action" aria-hidden="true">Open →</span>
    </button>
  );
}
